var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafetyIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    stroke: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 25.9375C15.3217 25.9375 14.0625 24.6783 14.0625 23.125C14.0625 21.5717 15.3217 20.3125 16.875 20.3125C18.4283 20.3125 19.6875 21.5717 19.6875 23.125C19.6875 24.6783 18.4283 25.9375 16.875 25.9375ZM23.125 19.6875C21.5717 19.6875 20.3125 18.4283 20.3125 16.875C20.3125 15.3217 21.5717 14.0625 23.125 14.0625C24.6783 14.0625 25.9375 15.3217 25.9375 16.875C25.9375 18.4283 24.6783 19.6875 23.125 19.6875ZM16.875 24.6875C17.7379 24.6875 18.4375 23.9879 18.4375 23.125C18.4375 22.2621 17.7379 21.5625 16.875 21.5625C16.0121 21.5625 15.3125 22.2621 15.3125 23.125C15.3125 23.9879 16.0121 24.6875 16.875 24.6875ZM23.125 18.4375C23.9879 18.4375 24.6875 17.7379 24.6875 16.875C24.6875 16.0121 23.9879 15.3125 23.125 15.3125C22.2621 15.3125 21.5625 16.0121 21.5625 16.875C21.5625 17.7379 22.2621 18.4375 23.125 18.4375ZM14.375 17.5C14.375 15.7741 15.7741 14.375 17.5 14.375H19.375V15.625H17.5C16.4645 15.625 15.625 16.4645 15.625 17.5V19.375H14.375V17.5ZM25.625 20.625H24.375V22.5C24.375 23.5356 23.5356 24.375 22.5 24.375H20.625V25.625H22.5C24.2259 25.625 25.625 24.2259 25.625 22.5V20.625Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyIcon3);
export default __webpack_public_path__ + "static/media/safety_icon3.0dd48da5e302dec5330a057d5f4ada22.svg";
export { ForwardRef as ReactComponent };